<template lang="html">
	<div id="app" class="main column no-header">
		<div class="background-login"></div>
		<div class="login subscribe active">
			<div class="ctn-img">
				<img src="~@/common/assets/img/logo-patrim.svg" alt="">
			</div>
			<div class="heading">
				Complétez votre inscription pour bénéficier de toutes les fonctionnalités Patrimoffice.
				<br><br> Ainsi que d'un essai gratuit d'un mois.
			</div>
			<form class="form-ui default-form-ui column" novalidate>
				<div class="ctn-duo-input row">
					<div class="form-elem-container left">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('prénom')}">
							<label for="prénom">Prénom</label>
							<input v-validate="'required|alpha_dash_spaces'" type="text" name="prénom" v-model="user.firstname">
						</div>
						<div v-if="errors.has('prénom')" class="error-message">{{ errors.first('prénom') }}
						</div>
					</div>
					<div class="form-elem-container right">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('nom')}">
							<label for="">Nom</label>
							<input v-validate="'required|alpha_dash_spaces'" type="text" name="nom" v-model="user.lastname">
						</div>
						<div v-if="errors.has('nom')" class="error-message">{{ errors.first('nom') }}</div>
					</div>
				</div>
				<div class="form-elem-container right">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('email')}">
						<label for="email">Votre e-mail</label>
						<input data-vv-validate-on="blur" v-validate="'required|email'" type="email" name="email" v-model="user.email">
					</div>
					<div v-if="errors.has('email')" class="error-message">{{ errors.first('email') }}</div>
				</div>
				<div class="ctn-duo-input row">
					<div class="form-elem-container left">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('téléphone')}">
							<label for="password">Téléphone</label>
							<input v-validate="'required'" type="text" name="téléphone" v-model="user.phone">
						</div>
						<div v-if="errors.has('téléphone')" class="error-message">{{ errors.first('téléphone')
							}}
						</div>
					</div>
					<div class="form-elem-container right">
						<div class="ctn-input ctn-label ctn-date" v-inputUI :class="{error: errors.has('date de naissance')}">
							<label for="date de naissance">Date de naissance</label>
							<input v-validate="'required'" type="date" name="date de naissance" v-model="user.birthdate">
						</div>
						<div v-if="errors.has('date de naissance')" class="error-message">{{ errors.first('date de naissance') }}
						</div>
					</div>
				</div>
				<div class="ctn-duo-input row">
					<div class="form-elem-container left">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('mot de passe')}">
							<label for="mot de passe">Mot de passe</label>
							<input v-validate="'required'" type="password" name="mot de passe" v-model="user.password">
						</div>
						<div v-if="errors.has('mot de passe')" class="error-message">{{ errors.first('mot de passe') }}
						</div>
					</div>
					<div class="form-elem-container right">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('confirmation mot de passe')}">
							<label for="mot de passe">Confirmation mot de passe</label>
							<input v-validate="'required'" type="password" name="confirmation mot de passe" v-model="user.passwordConfirm">
						</div>
						<div v-if="errors.has('confirmation mot de passe')" class="error-message">{{
							errors.first('confirmation mot de passe') }}
						</div>
					</div>
				</div>
				<div class="check-container row">
					<radio-box :value="user.acceptDER" @change="setAcceptDER"/>
					<a target="_blank" class="link" href="https://patrimoffice-production.s3.eu-west-3.amazonaws.com/public/Fiche_Informations_Legales_PATRIMOFFICE.pdf">
						Je confirme avoir pris connaissance des informations du DER (Document d'Entrée en
						Relation) de Patrimoffice
					</a>
				</div>
				<div v-if="error.der" class="error-message">Vous devez accepter les DER</div>
				<div class="check-container row">
					<radio-box :value="user.acceptCGU" @change="setAcceptCGU"/>
					<a href="https://www.patrimoffice.com/cgu/" target="_blank" class="link">
						J'accepte les CGU
					</a>
				</div>
				<div v-if="error.cgu" class="error-message">Vous devez accepter les CGU</div>
			</form>
			<div class="ctn-connect">
				<div class="btn btn-red" @click="subscribe">
					Suivant
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {Validator} from 'vee-validate'
import LocalStorage from '@/common/services/local-storage'
import {ANONYMOUS_USER_LOGIN_KEY} from '../../utils/constants'

Validator.extend('alpha_dash_spaces', {
	getMessage: field => 'Le champ ' + field + ' ne peut contenir que des caractères des tirets et des espaces',
	validate: value => {
		for (let i = 0; i < value.length; i++) {
			if ('aàbcçdeéèfghijklmnopqrstuvwxyz -'.indexOf(value[i].toLowerCase()) === -1) {
				return false
			}
		}
		return true
	}
})

export default {
	name: 'AnonymousUpgrade',
	data () {
		return {
			user: {
				email: null,
				firstname: null,
				lastname: null,
				birthdate: null,
				address: {
					line: null,
					zip: null,
					city: null,
					country: null
				},
				phone: null,
				password: null,
				passwordConfirm: null,
				acceptDER: null,
				acceptCGU: null
			},
			error: {
				der: false,
				cgu: false
			}
		}
	},
	methods: {
		subscribe () {
			this.$validator.validate().then((validation) => {
				if (validation) {
					if (this.user.acceptDER && this.user.acceptCGU && this.user.password === this.user.passwordConfirm) {
						this.changePassword().then(() => {
							this.updateProfile()
						})
					} else {
						this.error.cgu = !this.user.cgu
						this.error.der = !this.user.der
					}
				}
			})
		},
		updateProfile () {
			this.$store.dispatch('saveProfile', this.user).then(() => {
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Félicitations',
					text: 'Votre compte a été validé, veuillez confirmer votre adresse email'
				})
				LocalStorage.removeItem(ANONYMOUS_USER_LOGIN_KEY)
				this.$store.dispatch('allClear')
				this.$router.push({ name: 'Login' })
			}).catch((error) => {
				console.log(error)
				let message = ''
				if (Object.keys(error.response.data.errors).indexOf('email') !== -1) message = 'Cette adresse email est déjà utilisé'
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: message
				})
			})
		},
		changePassword () {
			const loginRawData = LocalStorage.getItem(ANONYMOUS_USER_LOGIN_KEY)

			const login = JSON.parse(loginRawData)

			const currentPassword = login.username
			let data = new FormData()
			data.append('current_password', currentPassword)
			data.append('plain_password[first]', this.user.password)
			data.append('plain_password[second]', this.user.passwordConfirm)

			return this.$store.dispatch('editPassword', data)
		},
		setAcceptDER (value) {
			this.error.der = !value
			this.user.acceptDER = value
		},
		setAcceptCGU (value) {
			this.error.cgu = !value
			this.user.acceptCGU = value
		}
	}
}
</script>

<style lang="scss" scoped>

	.ctn-date {
		padding: 0.08rem;
	}

</style>



// WEBPACK FOOTER //
// src/views/Auth/AnonymousUpgrade.vue